<template>
	<div>
		<v-card>
			<v-toolbar flat dense class="info" dark>
				<v-toolbar-title class="subheading">Acknowledgement</v-toolbar-title>
			</v-toolbar>
			<v-card-text class="text-xs-left">
				<v-checkbox v-model="acknowledged" :label="acknowledgementText"></v-checkbox>

				<v-btn color="primary" :disabled="!acknowledged" @click="onAcknowledgeClick">Acknowledge</v-btn>

				<div class="mt-3 disclaimer">
					This position description outlines the main duties however other tasks may be assigned at the discretion of the organisation. You are required to be familiar with the content of this position description and make all reasonable efforts to follow it.
				</div>
			</v-card-text>
		</v-card>
		<v-dialog v-model="confirmDialog" persistent max-width="500px">
			<v-card>
				<v-form>
					<v-toolbar flat dense cad>
						<v-toolbar-title class="subheading">Confirm Acknowledgement</v-toolbar-title>
						<v-spacer></v-spacer>
					</v-toolbar>

					<v-divider></v-divider>
					<v-card-text class="acknowledge-message">
						Please confirm that you acknowledge, agree and understand all aspects of this position description.
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn :disabled="!acknowledged || isAcknowledging" flat @click="onCancelClick">Cancel</v-btn>
						<v-btn :disabled="!acknowledged || isAcknowledging" :loading="isAcknowledging" color="primary" flat @click="onAcknowledge">Confirm <span slot="loader">Please Wait...</span></v-btn>
					</v-card-actions>
				</v-form>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	export default {
		props: {
			isAcknowledging: {
				type: Boolean,
				required: true
			}
		},
		data() {
			return {
				acknowledged: false,
				confirmDialog: false
			};
		},
		computed: {
			acknowledgementText() {
				return "I acknowledge, agree and understand all aspects of this position description.";
			}
		},
		methods: {
			onAcknowledge() {
				this.$emit('onAcknowledge');
			},
			onAcknowledgeClick() {
				this.confirmDialog = true;
			},
			onCancelClick() {
				this.confirmDialog = false;
			}
		}
	};
</script>

<style scoped>
	.disclaimer {
		color: rgba(0, 0, 0, 0.54);
		font-size: 12px !important;
	}
	.acknowledge-message {
		margin-top: 20px;
		margin-bottom: 20px;
	}
</style>